import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import * as AppStore from '../store/AppDataContainer';
import * as DynamicScripts from '../common/DynamicScripts';
import { DataManager } from '../common/DataManager';
import XMLViewer from 'react-xml-viewer'
import Cookies from 'universal-cookie';
import PubSub from 'pubsub-js';
import LoadingOverlay from 'react-loading-overlay-ts';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import ItemEditForm from './ItemEditForm';
import ItemEdit from './ItemEdit';
import EditButton from './EditButton';
import Pagination from './Pagination';
import DropdownTreeSelectBox from './DropdownTreeSelectBox';
import MultipleDropdownSelect from './MultipleDropdownSelect';
import MultiSelectDropdown from './MultiSelectDropdown'
import InitiateGoogleAmazonApiConfig from './InitiateGoogleAmazonApiConfig';
import JSONToHtmlViewer from './GenericComponents/JSONToHtmlViewer';
import SingleSelectDropdown from './SingleSelectDropdown';
import parse  from 'html-react-parser';
import CustomLoader from './CustomLoader/CustomLoader';

const queryString = require('query-string');
var decode = require('decode-html');
// const htmlreactparse = require('html-react-parser');
const cookies = new Cookies();
const xmlJson = require('xml-js');

const ComponentBuilder = () => {
    let appState = useSelector(state => state) as ApplicationState;
    const dispatch = useDispatch();
    let dataManager = new DataManager(appState);

    const [cssStyles, setCssStyles] = useState("");
    const [Element, setElement]:any = useState({});
    const [pageLoaded, setPageLoaded] = useState(false);
    //let pageElementsState: AppStore.KeyValue = {};
    const subscriberEvents = [];

    let styles: AppStore.CSS[] = [];

    const renderHtml = () => {
        return (
            pageLoaded && Object.keys(Element).length > 0 ?
                <React.Fragment>
                    <LoadingOverlay
                        active={appState.appStore && appState.appStore.IsLoading}
                        spinner
                        text='Page Loading ......'
                    >
                        <style>{cssStyles}</style>
                        {Element}
                        <NotificationContainer />
                    </LoadingOverlay>
                </React.Fragment>
                :
                <CustomLoader />
                // <LoadingOverlay
                //     active={true}
                //     spinner
                //     text='Page Loading ......'
                // >
                // </LoadingOverlay>
        );
    }

    const getComponent = (component: AppStore.Component): any => {
        let htmlTemplate = getTemplate(component.Template, component);
        if (htmlTemplate && htmlTemplate.MockData && htmlTemplate.InstanceId) {
            let elementState: AppStore.KeyValue = {};
            elementState[htmlTemplate.InstanceId] = JSON.parse(htmlTemplate.MockData);
            if (appState && appState.appStore && appState.appStore.MockData) {
                appState.appStore.MockData = { ...elementState, ...appState.appStore.MockData };
            }
            else if (appState && appState.appStore) {
                appState.appStore.MockData = {};
                appState.appStore.MockData = { ...elementState };
            }
            //dispatch(AppStore.layoutActionCreators.setAppState({ MockData: elementState }));

        }
        let template = null;
        try {
            template = JSON.parse(getTemplateContent(htmlTemplate)) as AppStore.Element;
        }
        catch (e:any) {
            let result = e.Message;
            console.error("Invalid Template " + (htmlTemplate ? htmlTemplate.InstanceId : ""));
            console.log(htmlTemplate ? htmlTemplate.InstanceId : "");
        }
        if (template !== null) {
            let dataSet = {};
            if (component.DataBindings) {
                dataSet = getDataSource(component.DataBindings);
            }
            let element = getElement(template, dataSet, component, 1, 0, dataSet);

            if (component.Subscribers && component.Subscribers.length > 0) {
                component.Subscribers.map(s => { const event = PubSub.subscribe(s.Name, (e: any, dataPublished: any) => subscriberHandler(e, dataPublished, component, s)); subscriberEvents.push(event); });
            }
            //setElement(element);
            return element;
        }
    }

    const getTemplateContent = (htmlTemplate: AppStore.ESComponent | null): string => {
        if (htmlTemplate && htmlTemplate.TemplateContent && htmlTemplate.TemplateContent.trim() !== "") {
            return htmlTemplate.TemplateContent;
        }
        else if (htmlTemplate && htmlTemplate.TemplateContentNS && htmlTemplate.TemplateContentNS.trim() !== "") {
            return htmlTemplate.TemplateContentNS;
        }
        return "";
    }

    const getElement = (element: AppStore.Element, dataContainer: any, component: AppStore.Component, itemIndex: number, dataIndex: number, dataState: any): any => {
        if (isElementRendered(element, dataContainer, itemIndex, dataState)) {
            if (element.IsComponent && element.Component) {
                let componetData = getData(element.Component.DataBindings, dataContainer, dataIndex, dataState);
                let htmlTemplate = getTemplate(element.Component.Template, element.Component);
                let componentElement = JSON.parse(getTemplateContent(htmlTemplate)) as AppStore.Element;
                let reactElement = getElement(componentElement, componetData, element.Component, itemIndex, dataIndex, { "currentState": componetData, "parentState": { "currentState": dataContainer, "parentState": dataState } });
                return reactElement;
            }
            else {
                if (element.Name.toLowerCase() === "script") {
                    var s = document.createElement('script');
                    s.type = 'text/javascript';
                    if (!document.getElementById(component.Id)) {
                        if (element.InnerElements && element.InnerElements.length > 0) {
                            let innerScript = getElement(element.InnerElements[0], dataContainer, component, 0, dataIndex, dataState);
                            s.innerText = '$( document ).ready(function() { try {' + innerScript + '}catch(e){console.log(e);}});';
                            s.id = component.Id;
                            document.body.appendChild(s);
                            //s.async = true;                        
                        }
                        else if (element.Properties && element.Properties.length > 0) {
                            let srcProperty = element.Properties.find(t => t.Name === 'src');
                            if (srcProperty) {
                                s.src = srcProperty.Value;
                                //s.id = component.Id;
                                document.body.appendChild(s);
                            }
                        }
                    }
                }
                if (element.Name.toLowerCase() === "innertext") {
                    if (element.Properties && element.Properties[0].IsDatabound && element.Properties[0].IsDatabound === true) {
                        let innerText = DynamicScripts.EvaluteExpression(element.Properties[0].Value, dataContainer, dataIndex, appState, dataState);
                        //reactInnerElements.push(innerText);       
                        if (element.Properties[0].IsXml) {
                            //return beautify(innerText);
                            return innerText;
                        }
                        return parse(innerText ? innerText.toString() : "");
                    }
                    else {
                        if (element.Properties && element.Properties.length > 0 && element.Properties[0].Value && element.Properties[0].Value.trim() !== '') {
                            if (element.Properties[0].IsPlainText) {
                                return element.Properties[0].Value;
                            }
                            let innerText:any = element.Properties ? parse(element.Properties[0].Value) : "";
                            innerText = innerText.replace(new RegExp('&nbsp;', 'g'), '\xA0');
                            //console.log(innerText);
                            return innerText;
                        }
                        return "";
                    }
                }
                let reactInnerElements: any[] = [];
                //if (element.IsRepeated) {
                //    let repeatList = getData(element.DataBindings, dataContainer, dataIndex) as any[];
                //    element.IsRepeated = false;
                //    for (let i = 0; i < repeatList.length - 1; i++) {
                //        let repeatElement = getElement(element, repeatList[i], component, i + itemIndex + 1, i);
                //        reactInnerElements.push(repeatElement);
                //    }
                //}
                if (element.InnerElements && element.InnerElements.length > 0) {
                    element.InnerElements.forEach((innerElement: AppStore.Element, index: number) => {
                        let innerItemIndex = itemIndex + index + 1;
                        if (innerElement.IsRepeated) {
                            let repeatList = getData(innerElement.DataBindings, dataContainer, dataIndex, dataState) as any[];
                            innerElement.IsRepeated = false;
                            if (repeatList && repeatList.length > 0) {
                                for (let i = 0; i < repeatList.length; i++) {
                                    let repeatElement = getElement(innerElement, repeatList[i], component, i + innerItemIndex + 1, i, { "currentState": repeatList[i], "parentState": { "currentState": dataContainer, "parentState": dataState } });
                                    reactInnerElements.push(repeatElement);
                                }
                            }
                            innerElement.IsRepeated = true;
                        }
                        else {
                            let reactInnerElement = getElement(innerElement, dataContainer, component, innerItemIndex, dataIndex, dataState);
                            reactInnerElements.push(reactInnerElement);
                        }
                    });
                }

                let attributes = getElementProperties(element, dataContainer, component, itemIndex, dataIndex, dataState);
                if (element.Name.toLowerCase() === "xmlviewer") {
                    return React.createElement(XMLViewer, attributes, reactInnerElements.length > 0 ? reactInnerElements : null);
                }
                else if (element.Name.toLowerCase() === "editbutton") {
                    //let jsonviewerAttribtutes = { "application": "contentstudio", "pagetype": "collectiondasboard", "collectionid": "3972db46-96c7-4a63-b165-2052332db081", "override": "true"};
                    return React.createElement(EditButton, {}, reactInnerElements.length > 0 ? reactInnerElements : null);
                }
                else if (element.Name.toLowerCase() === "pagination") {
                    var pageCount = 0;
                    let paginationAttributes = { count: attributes.count, rowsPerPage: attributes.rowsPerPage, 
                        page: pageCount,
                         onChange: attributes.onChange,
                         addionalConfig: attributes.addionalConfig
                        };
                    return React.createElement(Pagination, paginationAttributes, reactInnerElements.length > 0 ? reactInnerElements : null);
                }

                else if (element.Name.toLowerCase() === "dropdowntreeselect") {
                    let dropdownTreeAttributes = { value: attributes.value, url: attributes.url, newval: attributes.newval, title: attributes.title, num: attributes.num, onSelectClick: attributes.onSelectClick, onSelectChange: attributes.onSelectChange, onSearch: attributes.onSearch };
                    return React.createElement(DropdownTreeSelectBox, dropdownTreeAttributes, reactInnerElements.length > 0 ? reactInnerElements : null);
                }
                else if (element.Name.toLowerCase() === "multipledropdownselect") {
                    let multipleDropdownAttributes = { onChange: attributes.onChange, dropDownData: attributes.dropDownData, selectedData: attributes.selectedData, placeholderValue: attributes.placeholder };
                    return React.createElement(MultipleDropdownSelect, multipleDropdownAttributes, reactInnerElements.length > 0 ? reactInnerElements : null);
                }
                else if (element.Name.toLowerCase() === "multiselectdropdown") {
                    let multiSelectAttributes = { optionalProps: attributes.optionalProps, label: attributes.label, limitTags: attributes.limitTags, selectAllLabel: attributes.selectAllLabel, onChange: attributes.onChange, items: attributes.items, initialDefaultValue: attributes.initialDefaultValue, placeholder: attributes.placeholder };
                    return React.createElement(MultiSelectDropdown, multiSelectAttributes, reactInnerElements.length > 0 ? reactInnerElements : null);
                }
                else if (element.Name.toLowerCase() === "initiategoogleamazonapiconfig") {
                    let apiConfig = {  };
                    return React.createElement(InitiateGoogleAmazonApiConfig, apiConfig, reactInnerElements.length > 0 ? reactInnerElements : null);
                }

                else if (element.Name.toLowerCase() === "singleselectdropdown")
                    { let singleSelectAttributes = {
                       data:attributes.data,
                       addionalConfig: attributes.addionalConfig,
                       onChange: attributes.onChange,
                       onInputChange: attributes.onInputChange,
                       inputValue: attributes.inputValue
                    };
   
                    return React.createElement(SingleSelectDropdown, singleSelectAttributes,
                        reactInnerElements.length > 0 ? reactInnerElements : null); 
                       }    
                else if (element.Name.toLowerCase() === "jsontohtmlviewer"){ 
                    let agReactTableAttributes = {
                        jsonData:attributes.jsonData
                    };
   
                    return React.createElement(JSONToHtmlViewer, agReactTableAttributes,
                        reactInnerElements.length > 0 ? reactInnerElements : null); 
                       }

                else if (element.Name.toLowerCase() === "itemedit") {
                    let editItemData = attributes.Expression ? DynamicScripts.EvaluteExpression(attributes.Expression, dataContainer, dataIndex, appState, dataState) : null;
                    let details = JSON.parse(attributes.Details);
                    let jsonviewerAttribtutes = {
                        "application": details.application ? details.application : "contentstudio", "className": details.className ? details.className : "", "pagetype": "itemdashboard", "collectionid": editItemData && editItemData.collectionid ? editItemData.collectionid : details.collectionid, "itemid": editItemData && editItemData.id ? editItemData.id : details.id, "override": "true", "fields": details.fields, "templates": details.Templates ? details.Templates.split(",") : [], component
                    }
                    return React.createElement(ItemEdit, jsonviewerAttribtutes, reactInnerElements.length > 0 ? reactInnerElements : null);
                }
                else if (element.Name.toLowerCase() === "itemeditform") {
                    //let jsonviewerAttribtutes = { "application": "contentstudio", "pagetype": "collectiondasboard", "collectionid": "3972db46-96c7-4a63-b165-2052332db081", "override": "true" };
                    return React.createElement(ItemEditForm, {}, reactInnerElements.length > 0 ? reactInnerElements : null);
                }


                return React.createElement(element.Name, attributes, reactInnerElements.length > 0 ? reactInnerElements : null);
            }
        }
    }

    const getElementProperties = (element: AppStore.Element, dataContainer: any, component: AppStore.Component, itemIndex: number, dataIndex: number, dataState: any) => {
        let attributes: AppStore.KeyValue = {};
        if (element.Properties) {
            element.Properties.forEach((property: AppStore.Attribute) => {
                try {
                    switch (property.Name.toLowerCase()) {
                        case "class":
                        case "classname":
                            attributes["className"] = getCSS(property, dataContainer, itemIndex, dataIndex, component.Template.Id, component.Style ? component.Style.Id : "", dataState);
                            break;
                        case "event":
                            if (property.Events) {
                                for (let e = 0; e < property.Events.length; e++) {
                                    let eventProps = property.Events[e];
                                    if (eventProps) {
                                        let stateKey = property.Events[e].StateKey ? property.Events[e].StateKey : "";
                                        if (stateKey && stateKey !== "") {
                                            let elementState: AppStore.KeyValue = {};
                                            elementState[stateKey] = attributes["defaultValue"];
                                            let elementId = component.Id.trim();
                                            if (appState.appStore && (!appState.appStore.ComponentsState || !appState.appStore.ComponentsState[elementId] || (appState.appStore.ComponentsState[elementId][stateKey] === undefined))) {
                                                dispatch(AppStore.layoutActionCreators.setComponentState(appState.appStore ? appState.appStore : {}, elementState, elementId) as any);
                                            }
                                            //pageElementsState[elementId] = {...pageElementsState[elementId], ...elementState};
                                        }
                                        attributes[property.Events[e].Name] = (e: any) => eventHandler(e, appState, dataContainer, component, eventProps, dataIndex, dataState);
                                    }
                                }
                            }

                            //attributes[property.Value] = (e: any) => eventHandler(e, dataContainer, property.Name, component);
                            break;
                        case "style":
                            let styleProps: AppStore.StyleProps[] = property.StyleProps ? property.StyleProps : [];
                            let styles = "";
                            let styleAttributes: AppStore.KeyValue = {};
                            for (let i = 0; i < styleProps.length; i++) {
                                if (styleProps[i].IsExpression) {
                                    let stylePropValue = DynamicScripts.EvaluteExpression(styleProps[i].Value, dataContainer, dataIndex, appState, dataState);
                                    switch (styleProps[i].Key) {
                                        case "backgroundImage":
                                            styleAttributes[styleProps[i].Key] = "url('" + stylePropValue + "')";
                                            break;
                                        default:
                                            styleAttributes[styleProps[i].Key] = stylePropValue;
                                    }


                                }
                            }
                            attributes["style"] = styleAttributes;
                            //console.error("style need to be handled");
                            break;
                        case "defaultvalue":
                            if (property.Value && property.Value.toLowerCase().indexOf("querystring") > -1) {
                                let defaultParams = property.Value.split("?");
                                if (defaultParams.length > 1) {
                                    let qsKey = defaultParams[0].trim().split(":")[1];
                                    let qsValue = dataManager.getQueryString(qsKey);
                                    if (qsValue) {
                                        attributes["defaultValue"] = qsValue;
                                    }
                                    else {
                                        attributes["defaultValue"] = defaultParams[1].trim();
                                    }
                                }
                                else {
                                    let qsKey = property.Value.split(":")[1];
                                    let qsValue = dataManager.getQueryString(qsKey);
                                    if (qsValue) {
                                        attributes["defaultValue"] = qsValue;
                                    }
                                }
                            }
                            else {
                                if (property.IsDatabound && property.IsDatabound === true) {
                                    attributes[property.Name] = DynamicScripts.EvaluteExpression(property.Value, dataContainer, dataIndex, appState, dataState);
                                }
                                else {
                                    attributes[property.Name] = property.Value;
                                }
                            }
                            break;
                        default:
                            if (property.IsDatabound && property.IsDatabound === true) {
                                attributes[property.Name] = DynamicScripts.EvaluteExpression(property.Value, dataContainer, dataIndex, appState, dataState);
                            }
                            else {
                                attributes[property.Name] = property.Value;
                            }
                    }
                }
                catch (ex) {
                    console.log("Error in ComponentBuilder getElement templatename " + component.Template.Id + " property " + JSON.stringify(property) + " error message " + JSON.stringify(ex));
                }
            });
        }
        attributes.key = component.Template.Id + "_" + element.Name + "_" + itemIndex + "_" + dataIndex;
        if (!attributes.id) {
            attributes.id = attributes.key;
        }


        if ((element.Name === "input") && element.Properties) {
            let elementTypeProp = element.Properties.find(e => e.Name === "type");
            let elementEventProp = element.Properties.find(e => e.Name.toLowerCase() === "event");
            if (elementTypeProp && elementEventProp && elementEventProp.Events && elementEventProp.Events[0].StateKey) {
                switch (elementTypeProp.Value) {
                    case "text":
                        //let elementValue = getComponentElementData(component.Id, elementEventProp.Events[0].StateKey);
                        //if (elementValue) {
                        //    attributes["defaultValue"] = elementValue;
                        //}

                        if (attributes && attributes.id && document.getElementById(attributes.id)) {
                            let htmlElement = (document.getElementById(attributes.id) as HTMLInputElement);
                            //if (htmlElement && !attributes["defaultValue"]) {
                            //    htmlElement.value = "";
                            //}
                            //else {
                            //    htmlElement.value = attributes["defaultValue"];
                            //}
                            if (htmlElement) {
                                attributes["defaultValue"] = htmlElement.value;
                            }
                        }
                        break;
                }
            }
        }

        if ((element.Name === "textarea") && element.Properties) {
            let elementEventProp = element.Properties.find(e => e.Name.toLowerCase() === "event");
            if (elementEventProp && elementEventProp.Events && elementEventProp.Events[0].StateKey) {
                let elementValue = getComponentElementData(component.Id, elementEventProp.Events[0].StateKey);
                if (elementValue) {
                    attributes["defaultValue"] = elementValue;
                }

                if (attributes && attributes.id && document.getElementById(attributes.id)) {
                    let htmlElement = (document.getElementById(attributes.id) as HTMLInputElement);
                    if (htmlElement && htmlElement.value) {
                        htmlElement.value = attributes["defaultValue"];
                    }
                }

                //if (attributes && attributes.id && document.getElementById(attributes.id)) {  
                //    let textElement : any = document.getElementById(attributes.id);
                //    let htmlElement = (document.getElementById(attributes.id) as HTMLInputElement);
                //    if (htmlElement && htmlElement.value) {
                //        attributes["defaultValue"] = htmlElement.value;
                //    }
                //    else if (textElement && textElement.value) {
                //        attributes["defaultValue"] = textElement.value;
                //    }
                //}
            }
        }

        return attributes;
    }

    const getComponentElementData = (componentKey: string, elementKey: string) => {
        if (appState.appStore && appState.appStore.ComponentsState && appState.appStore.ComponentsState.hasOwnProperty(componentKey)
            && appState.appStore.ComponentsState[componentKey].hasOwnProperty(elementKey)) {
            let elementData = appState.appStore.ComponentsState[componentKey][elementKey];
            return elementData;
        }
        return null;
    }

    const onReactPlayerSuccess = (success: any) => {
        //console.log(success.ref);
        success.ref.ready(() => {
            let qualityLevels = success.ref.qualityLevels();
            qualityLevels.on('addqualitylevel', (event: any) => {
                if (event && event.qualityLevel) {
                    let qualityLevel = event.qualityLevel;
                    if (qualityLevel.height >= 720) {
                        qualityLevel.enabled = true;
                    } else {
                        qualityLevel.enabled = false;
                    }
                }
            });
        });
    }

    const isElementRendered = (element: AppStore.Element, dataContainer: any, itemIndex: number, dataState: any): boolean => {
        if (element.IsRendered && element.IsRendered !== "") {
            if (!dataContainer) {
                const cookies = new Cookies();
                let dataManager = new DataManager(appState);
                var funExpression = eval("($$t,$$index,appState,cookies,dataManager,dataState) => " + decode(element.IsRendered.trim()));
                //return funExpression(dataItem, dataIndex, appState, beautify);
                return funExpression(dataContainer, itemIndex, appState, cookies, dataManager, dataState);
            }
            if (DynamicScripts.EvaluteExpression(element.IsRendered, dataContainer, itemIndex, appState, dataState)) {
                return true;
            }
            else {
                return false;
            }
        }
        return true;
    }

    const getSrcAttribute = (template: AppStore.Element, dataContainer: any) => {

    }

    const getPageCSS = (cssList: AppStore.CSS[]) => {
        let strCss = "";
        //cssList.filter((m, i, originalArray) =>  originalArray.findIndex(n => n.Key === m.Key) === i)
        //    .forEach(t => {
        //    strCss = strCss + decode(t.Value);
        //})
        cssList.forEach(t => {
            strCss = strCss + decode(t.Value);
        })
        return strCss;
    }

    const getCSS = (property: any, dataContainer: any, itemIndex: number, dataIndex: number, templateName: string, cssNamespace: string, dataState: any) => {
        var cssclassNames = "";
        if (property.IsExpression && property.IsExpression === true) {
            cssclassNames = DynamicScripts.EvaluteExpression(property.Value, dataContainer, dataIndex, appState, dataState);
            cssclassNames = cssclassNames.replace(new RegExp('cssnamespace', 'g'), templateName + "_" + cssNamespace);
        }
        else {
            cssclassNames = property.Value.replace(new RegExp('cssnamespace', 'g'), templateName + "_" + cssNamespace);
        }
        return cssclassNames;
    }

    const setPageCSS = (template: AppStore.ESComponent, component: AppStore.Component) => {
        let cssKey: string = component.Template.Id + "_" + component.Style.Id;
        let cssValue: any = { Key: '', Value: '' };
        cssValue.Key = cssKey;
        let templateStyle = template.ComponentStyle ? template.ComponentStyle.find(s => s.Key === component.Style.Id) : { Style: "", Key: component.Style.Id };
        cssValue.Value = templateStyle && templateStyle.Style ? templateStyle.Style.replace(new RegExp('cssnamespace', 'g'), cssKey) : "";
        if (styles.findIndex((t) => t.Key === cssKey) === -1) {
            styles.push(cssValue);
        }
        //setCssArray(cssArray.concat(cssValue));
    }

    const getPageDataSuccessHandler = (data: any, key: string, itemPath: string, itemIndex: number, successHandlerScript: string = "") => {
        if (data) {
            if (successHandlerScript !== "") {
                console.log(successHandlerScript);
            }
            let result = DynamicScripts.EvaluteExpression("$$t." + itemPath.trim(), data, itemIndex, appState, null);
            if (successHandlerScript !== "") {
                var funExpression = eval("(data,AppStore,appState,dataManager) => {" + successHandlerScript + "}");
                funExpression(data, AppStore, appState, dataManager);
            }
            else {
                let dataSet: AppStore.KeyValue = {};
                dataSet[key] = result;
                dispatch(AppStore.layoutActionCreators.setAppDataSet({}, dataSet, key) as any);
                dispatch(AppStore.layoutActionCreators.setAppState({ RefreshPage: true }) as any);
            }
        }
        else {
            // let dataSet: AppStore.KeyValue = {};
            // dataSet[key] = {};
            // dispatch(AppStore.layoutActionCreators.setAppDataSet({}, dataSet, key));
            // dispatch(AppStore.layoutActionCreators.setAppState({ RefreshPage: true }));
            let funExpression = eval("(data,AppStore,appState,dataManager) => {" + successHandlerScript + "}");
            funExpression(data, AppStore, appState, dataManager);
        }
        // If multiple API calls, then only for last API call completion Page loding should stop
        if (successHandlerScript.search("dataManager.loadDatasourceByKey") == -1) {
            dispatch(AppStore.layoutActionCreators.setAppState({ IsLoading: false }) as any);
        }

        //mergerAPIwithMockData(datacontainer[key], dataStore.GetData(Constants.MockData) && dataStore.GetData(Constants.MockData).mockdatacontainer ? dataStore.GetData(Constants.MockData).mockdatacontainer[key] : dataStore.GetData(Constants.MockData));        
    }


    const eventHandler = (e: any, appState: ApplicationState, dataContainer: any, component: AppStore.Component, event: AppStore.Event, index: number, dataState: any) => {
        if (event.IsPostback === undefined || event.IsPostback === true) {
            dispatch(AppStore.layoutActionCreators.setAppState({ IsLoading: true }) as any);
        }
        //console.log(event);
        //let dynamicScript = component.DynamicScripts.find((t) => t.Name === event.DynamicScript);           
        let elementState: AppStore.KeyValue = {};
        if (event && event.StateKey) {
            elementState[event.StateKey] = e.target.value;
            let elementId = component.Id.trim();
            dispatch(AppStore.layoutActionCreators.setComponentState(appState.appStore ? appState.appStore : {}, elementState, elementId) as any);

            //if (event.StateKey === "Request" && appState.appStore && appState.appStore.ComponentsState) {
            //    appState.appStore.ComponentsState.ModalDetails.Resource.Request = JSON.parse(e.target.value);
            //    dispatch(AppStore.layoutActionCreators.setComponentState(appState.appStore ? appState.appStore : {}, appState.appStore.ComponentsState.ModalDetails, "ModalDetails"));
            //}            
        }

        if (event && event.DynamicScript && event.DynamicScript.trim() !== "") {
            var funExpression = eval("(e,AppStore,appState,dataManager,dataContainer,component,event,index,NotificationManager,dataState) => {" + decode(event.DynamicScript) + "}");
            return funExpression(e, AppStore, appState, dataManager, dataContainer, component, event, index, NotificationManager, dataState);
        }
    }


    const subscriberHandler = (e: any, dataContainer: any, component: AppStore.Component, subscriber: AppStore.Subscriber) => {
        console.log(subscriber.Name);
        //appState = useSelector(state => state) as ApplicationState;
        //let dynamicScript = component.DynamicScripts.find((t) => t.Name === event.DynamicScript);        
        if (subscriber && subscriber.DynamicScript && subscriber.DynamicScript.trim() !== "") {
            var funExpression = eval("(e,dataContainer,component,subscriber,dataManager,appState,AppStore) => {" + decode(subscriber.DynamicScript) + "}");
            return funExpression(e, dataContainer, component, subscriber, dataManager, appState, AppStore);
        }
    }

    const getMicroContent = (property: any) => {
        var details = property.Value.split(":");
        switch (property.DataSourceType) {
            case "MicroContentString":
                return dataManager.getMicroContentString(details[0].trim(), details[1].trim());
            case "MicroContentLink":
                return dataManager.getMicroContentLink(details[0].trim(), details[1].trim(), details[2].trim());
            case "MicroContentImage":
                return dataManager.getMicroContentImage(details[0].trim(), details[1].trim());
            case "QueryString":
                return dataManager.getQueryString(property.Value.trim());
            case "Cookie":
                var cookieDetails = property.Value.split(",");
                var cookieValue = cookies.get(cookieDetails[0]);
                if (cookieValue) {
                    console.log(cookieValue);
                    return cookieValue === "false" ? false : true;
                }
                else {
                    console.log(cookieDetails[1] === "false" ? false : true);
                    return cookieDetails[1] === "false" ? false : true;
                }
        }
    }

    const getDataSource = (dataSources: AppStore.DataBind[]) => {
        var dataSet: AppStore.KeyValue = {};
        dataSources.forEach((dataSource: AppStore.DataBind) => {
            if (appState.appStore && appState.appStore.DataSet) {
                if (dataSource.DataPath && dataSource.DataPath.trim() !== "") {
                    let componentData = appState.appStore.DataSet.find((t) => { return t[dataSource.Name] });
                    dataSet[dataSource.Name] = DynamicScripts.EvaluteExpression(dataSource.DataPath, componentData, -1, appState, null);
                }
                else {
                    dataSet[dataSource.Name] = appState.appStore.DataSet.find((t) => { return t[dataSource.Name] });
                }

                //Need to implement Datapath
            }
        });
        return dataSet;
    }

    const getData = (dataSources: AppStore.DataBind[], dataContainer: any, index: number, dataState: any) => {
        var dataSet: any = null;
        dataSources.forEach((dataSource: AppStore.DataBind) => {
            if (dataContainer) {
                dataSet = DynamicScripts.EvaluteExpression(dataSource.DataPath, dataContainer, index, appState, dataState);
            }
        });
        return dataSet;
    }

    const getTemplate = (template: AppStore.Template, component: AppStore.Component) => {
        if (appState.appStore && appState.appStore.SiteConfiguration && appState.appStore.SiteConfiguration.Components) {
            let selectedTemplate = appState.appStore.SiteConfiguration.Components.find(t => t.InstanceId === template.Id);
            selectedTemplate = selectedTemplate ? selectedTemplate : {}
            //switch (template.Id) {
            //    case "studioclassificationmasthead":
            //        setPageCSS(selectedTemplate, component);
            //        return { ...selectedTemplate, HtmlContent: Constants.Masthead };
            //    case "homecarousel2":
            //        setPageCSS(selectedTemplate, component);
            //        return { ...selectedTemplate, HtmlContent: Constants.Carousel };                    
            //}

            //setPageCSS(selectedTemplate, component);
            //return { ...selectedTemplate, HtmlContent: Constants.Carousel };

            setPageCSS(selectedTemplate, component);
            return selectedTemplate;
        }
        else
            return null;
    }


    const subscriberTemplate = (msg: any, data: any) => {
        console.log(data);
        appState.appStore && appState.appStore.Layouts &&
            appState.appStore.Layouts[0].Zones.forEach(zone => zone.Sections.forEach(section => { section.Components.forEach(component => { if (component.Template.Id === data.component.Template.Id) { component.Template.Id = data.AssociatedTemplate.Template.Key; component.Style.Id = data.AssociatedTemplate.Style.Key; } }) }));
        dispatch(AppStore.layoutActionCreators.setAppState({ RefreshPage: true }) as any);
    };

    useEffect(() => {
        if (appState.appStore && appState.appStore.RefreshPage && appState.appStore.Layouts) {
            PubSub.clearAllSubscriptions();
            let siteConfig = appState.appStore.SiteConfiguration;
            if (siteConfig !== undefined) {
                let layoutStyle: any = siteConfig.LayoutStyle ? siteConfig.LayoutStyle : [];
                if (layoutStyle && layoutStyle !== undefined && layoutStyle.length > 0) {
                    let cssKey: string = "layoutstyle";
                    let cssValue: any = { Key: '', Value: '' };
                    cssValue.Key = cssKey;
                    cssValue.Value = layoutStyle[0].Style ? layoutStyle[0].Style : "";
                    if (styles.findIndex((t) => t.Key === cssKey) === -1) {
                        styles.push(cssValue);
                    }
                    setCssStyles(getPageCSS(styles));
                }

            }

            appState.appStore.Layouts.forEach((layout) => {
                let zoneElements = [];
                for (let z = 0; z < layout.Zones.length; z++) {
                    let zone = layout.Zones[z];
                    let componentElements = [];
                    if (zone.Sections) {
                        for (let s = 0; s < zone.Sections.length; s++) {
                            let section = zone.Sections[s];
                            if (section.Components) {
                                for (let c = 0; c < section.Components.length; c++) {
                                    let componentElement = getComponent(section.Components[c]);
                                    componentElements.push(componentElement);
                                    PubSub.subscribe('ItemEdit_TemplateChanged_' + section.Components[c].Id, (e: any, dataPublished: any) => subscriberTemplate(e, dataPublished));
                                }
                            }
                        }
                    }
                    let zoneElement = React.createElement(React.Fragment, null, ...componentElements);
                    zoneElements.push(zoneElement);
                }
                let pageElement = React.createElement(React.Fragment, null, ...zoneElements);
                setElement(pageElement);
                setCssStyles(getPageCSS(styles));
            });
            setPageLoaded(true);
            dispatch(AppStore.layoutActionCreators.setAppState({ RefreshPage: false }) as any);
        }
    }, [appState]);

    return renderHtml();
}

export default connect((state: ApplicationState) => state.appStore,
    AppStore.layoutActionCreators
)(ComponentBuilder);
